import { render, staticRenderFns } from "./myMonthlyReview.vue?vue&type=template&id=36cf09d5"
import script from "./myMonthlyReview.vue?vue&type=script&lang=js"
export * from "./myMonthlyReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports